import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-b2b-desktop-promotion1-strip',
  templateUrl: './b2b-desktop-promotion1-strip.component.html',
  styleUrls: ['./b2b-desktop-promotion1-strip.component.scss'],
  standalone: true,
  imports: [NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class B2bDesktopPromotion1StripComponent implements OnInit {
  @Input() src: string;

  constructor() {}

  ngOnInit() {}

  protected readonly environment = environment;
}
